import React from 'react';
import { B, D, Arr, Lbl, Lane } from '../shared/SvgHelpers';

export default function DiagramQ2Workflow() {
  return (
    <div className="space-y-2" data-testid="diagram-q2-workflow">
      <h4 className="text-sm font-bold text-amber-700">Q2-Workflow — Lieferantenreklamation (End-to-End)</h4>
      <p className="text-xs text-slate-500">Von der Q2-Anlage über das Lieferanten-Portal bis zum Rückfluss in Q1.</p>
      <svg viewBox="0 0 780 420" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        <Lane x={5} y={5} w={770} h={80} title="EINGANG (3 Szenarien)" color="#2563eb" />
        <Lane x={5} y={95} w={770} h={90} title="ANLAGE + KI + VERSAND" color="#7c3aed" />
        <Lane x={5} y={195} w={770} h={110} title="LIEFERANTEN-PORTAL (Token-Link)" color="#0891b2" />
        <Lane x={5} y={315} w={770} h={95} title="BEWERTUNG + RÜCKFLUSS" color="#16a34a" />

        {/* Eingang */}
        <B x={20} y={28} w={100} h={40} label={"aus Q1\n(Zukauf-Fehler)"} color="#2563eb" />
        <B x={140} y={28} w={100} h={40} label={"Wareneingang\n(WQS direkt)"} color="#d97706" />
        <B x={260} y={28} w={100} h={40} label={"Lohnfertigung\n(Subkontraktor)"} color="#7c3aed" />
        <Arr x1={70} y1={68} x2={200} y2={105} />
        <Arr x1={190} y1={68} x2={220} y2={105} />
        <Arr x1={310} y1={68} x2={250} y2={105} />

        {/* Q2 Anlage */}
        <B x={175} y={110} w={100} h={40} label={"Q2 anlegen\n(WQS/ZQM)"} color="#7c3aed" />
        <Arr x1={275} y1={130} x2={305} y2={130} />
        <B x={305} y={110} w={95} h={40} label={"KI-Erkennung\nLieferant"} color="#7c3aed" sub="P18" />
        <Arr x1={400} y1={130} x2={430} y2={130} />
        <B x={430} y={110} w={95} h={40} label={"Report-Typ\n4D / 8D"} color="#7c3aed" />
        <Arr x1={525} y1={130} x2={555} y2={130} />
        <B x={555} y={110} w={100} h={40} label={"Lieferantenbrief\n(KI, DE/EN)"} color="#7c3aed" sub="P20" />
        <Arr x1={655} y1={130} x2={685} y2={130} />
        <B x={685} y={110} w={85} h={40} label={"E-Mail\nmit Token"} color="#7c3aed" />

        {/* Portal */}
        <Arr x1={727} y1={150} x2={727} y2={220} />
        <B x={680} y={220} w={90} h={38} label={"Portal öffnet\n(kein Login)"} color="#0891b2" />
        <Arr x1={680} y1={239} x2={590} y2={239} />
        <B x={490} y={220} w={100} h={38} label={"Report ausfüllen\nPDF hochladen"} color="#0891b2" />
        <Arr x1={490} y1={239} x2={400} y2={239} />
        <D x={370} y={239} s={26} label={"Antwort\nim SLA?"} color="#d97706" />
        <Arr x1={370} y1={265} x2={370} y2={282} />
        <Lbl x={377} y={278} text="Nein" color="#dc2626" />
        <B x={310} y={282} w={120} h={30} label={"Eskalation\nL1/L2/L3 Einkauf"} color="#dc2626" />

        <Arr x1={344} y1={239} x2={250} y2={239} />
        <Lbl x={253} y={232} text="Ja" color="#16a34a" />
        <B x={145} y={220} w={100} h={38} label={"Internes\nReview (WQS)"} color="#0891b2" />

        {/* Bewertung + Rückfluss */}
        <Arr x1={195} y1={258} x2={195} y2={340} />
        <B x={135} y={340} w={115} h={40} label={"KI-Bewertung\nScore 0-100"} color="#16a34a" sub="P19" />
        <Arr x1={250} y1={360} x2={290} y2={360} />
        <D x={310} y={360} s={28} label={"Score\n?"} color="#d97706" />
        <Arr x1={338} y1={360} x2={385} y2={335} />
        <Lbl x={340} y={350} text="≥60" color="#16a34a" size={8} />
        <B x={385} y={320} w={80} h={32} label={"Kosten KI\n(P21)"} color="#16a34a" />
        <Arr x1={465} y1={336} x2={510} y2={336} />
        <B x={510} y={320} w={100} h={32} label={"Q2\nschließen"} color="#16a34a" />
        <Arr x1={610} y1={336} x2={660} y2={336} />
        <B x={660} y={320} w={115} h={32} label={"Rückfluss zu Q1\n(D4/D5/D7)"} color="#16a34a" />

        <Arr x1={338} y1={378} x2={385} y2={390} />
        <Lbl x={340} y={395} text="<60" color="#dc2626" size={8} />
        <B x={385} y={378} w={120} h={25} label="Zur Überarbeitung" color="#dc2626" />
      </svg>
    </div>
  );
}
